
  (function() {
    function initNewsletterForm() {
      const form = document.getElementById('footer-newsletter-form');
      
      if (!form) return;
      
      const messageEl = document.querySelector('[data-newsletter-message]');
      
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        
        const formData = new FormData(form);
        const email = formData.get('contact[email]');
        
        // Basic email validation
        if (!email || !email.includes('@')) {
          showMessage('Please enter a valid email address.', 'error');
          return;
        }
        
        // Submit the form
        fetch(form.action, {
          method: 'POST',
          body: formData,
          headers: {
            'Accept': 'application/json'
          }
        })
        .then(function(response) {
          if (response.ok) {
            showMessage('Thank you for subscribing!', 'success');
            form.reset();
          } else {
            showMessage('Something went wrong. Please try again.', 'error');
          }
        })
        .catch(function(error) {
          showMessage('Something went wrong. Please try again.', 'error');
        });
      });
      
      function showMessage(text, type) {
        if (!messageEl) return;
        
        messageEl.textContent = text;
        messageEl.className = 'footer-newsletter-message ' + type + ' visible';
        
        setTimeout(function() {
          messageEl.classList.remove('visible');
        }, 5000);
      }
    }
    
    // Initialize on load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initNewsletterForm);
    } else {
      initNewsletterForm();
    }
    
    // Reinitialize on Shopify theme editor events
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      document.addEventListener('shopify:section:load', initNewsletterForm);
    }
  })();
